module.exports = __webpack_public_path__ + "static/media/dsr_cer1.4b9083a5.svg";